<style>
.bg-primary {
  background-color: #2b4e8a !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Kuesioner Paket Kuesioner            
      <router-link to="/pelatihan/paket-kuesioner/tambah" class="ml-auto">
      <CButton color="success" class="btn-md">Tambah</CButton>
      </router-link>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/pelatihan/daftar-kuesioner"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Daftar Pertanyaan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/paket-kuesioner"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          style="background-color: #486ba7;"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Paket Kuesioner</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/laporan-kuesioner"
          class="nav-link p-3 px-5 font-weight-bold text-white"          
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Laporan Kuesioner</router-link>
      </li>
    </ul>
    <!-- Data Workshop -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" @change="changePageSize" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control"
            v-model="search" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <tr>
              <th colspan="3">Jawaban</th>
            </tr>
            <template #no="{item,index}">
              <td class="py-2">{{ indexed == 0 ? index +1: index+indexed + 1 }}</td>
            </template>
             <template #nama_paket="{item}">
              <td class="py-2">{{ item.namaKuesioner ? item.namaKuesioner: '-' }}</td>
            </template>
            <template #jmlh_pertanyaan="{item}">
              <td class="py-2 font-weight-bold">{{ item.jumlahPertanyaan }} Pertanyaan</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <router-link :to="'/pelatihan/paket-kuesioner/edit/'+item.idKuesioner">
                <CButton v-c-tooltip="'Lihat'" color="success" class="btn-sm" square>
                  <font-awesome-icon icon="eye" />
                </CButton>
                </router-link>&nbsp;&nbsp;
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" 
          :active-page.sync="currentPage" 
          :pages="pagination.totalPages"
          @change="pageChange" 
          responsive />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data provinsi -->
  </CCard>
</template>

<script>
import PaketKuesionerService from "../../../services/pelatihan/paket_kuesioner.service";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { Pagination } from "../../../mixins/Pagination";


const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "nama_paket",
    label: "Nama Paket",
    sorter: true,
    filter: false
  },
  {
    key: "jmlh_pertanyaan",
    label: "Jumlah Pertanyaan",
    sorter: true,
    filter: false
  },
  {
    key: "status",
    label: "Status",
    sorter: true,
    filter: false,
    _style: "text-align: center;",
  },  
  {
    key: "aksi",
    _style: "width:12%; text-align: center;",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Pelatihan",
  mixins: [AlertUtils,Pagination],
  data() {
    return {
      items: [],
      formData: {
        judul: "",
        file: "",
        idKuesioner: "",
        namaKuesioner: "",
        jumlahPertanyaan: "",
        status: "",
      },
      fileName: "Choose File...",
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      search: "",
      pageSize: "",
      pagination: {
        totalPages: 0
      },
      pagination: {
        totalPages: 0
      },
      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getData("0", this.pageSize, this.search);
  },
  methods: {
    changePageSize(e){
      var pageSize = '';
      if(e.target.value == "Semua Data"){
        pageSize = "500";
        this.pageSize = pageSize;
      }else{
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", this.pageSize, this.search);
    },
    cariData(){
      this.getData("0", this.pageSize, this.search);
    },
    pageChange(){
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    getData(currentPage, pageSize, filter){
      let loader = this.$loading.show({
        container: false ? null :this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PaketKuesionerService.getPaketKuesioner(currentPage, pageSize, filter)
      .then(response => {
        loader.hide();
        this.items = response.data.data.content;
        // comment console console.log(response.data.data.content  + "Ini data Kuesioner");
        this.pagination.totalPages = response.data.data.totalPages;
        this.currentPage = response.data.data.pageable.pageNumber + 1;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            PaketKuesionerService.deleteKuesioner(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
  }
};
</script>